import { Box, Button, Center, Flex, Text } from "@chakra-ui/react";

interface DrawMapButtonsProps {
  isEditingMode: boolean;
  polygonDataExists: boolean;
  onCancel: () => void;
  onSave: () => void;
  onClearArea: () => void;
  t: (key: string) => string;
  allowConfirm?: boolean;
}

export function DrawMapButtons({
  isEditingMode,
  polygonDataExists,
  onCancel,
  onSave,
  onClearArea,
  t,
  allowConfirm,
}: DrawMapButtonsProps) {
  return (
    <>
      <Text
        fontSize="14px"
        fontWeight="medium"
        color="gray.700"
        lineHeight="1.4"
        textAlign="center"
      >
        {isEditingMode ? t("editYourArea") : t("drawYourArea")}
      </Text>

      <Box>
        <Flex gap={3} justify="space-between">
          <Button
            flex={1}
            color="newBlue.500"
            variant="outline"
            size="sm"
            onClick={onCancel}
          >
            {t("backToPrevious")}
          </Button>

          <Button
            flex={1}
            layerStyle="ocean"
            _hover={{ layerStyle: "ocean" }}
            size="sm"
            onClick={onSave}
            isDisabled={!allowConfirm}
          >
            {t("confirmArea")}
          </Button>
        </Flex>
        <Center mt={2}>
          <Text
            color="newBlue.500"
            textDecoration="underline"
            cursor="pointer"
            fontSize="sm"
            onClick={onClearArea}
            opacity={!polygonDataExists ? 0.4 : 1}
            pointerEvents={!polygonDataExists ? "none" : "auto"}
          >
            {t("clearArea")}
          </Text>
        </Center>
      </Box>
    </>
  );
}
